type Props = {
  companyId: number | undefined;
  companyName: string | undefined;
  jobDescriptionTitle: string | undefined;
  isLogin: boolean | undefined;
  onClickLink?: (label: string) => void;
};

export const getJobDescriptionBreadCrumbs = ({
  companyId,
  companyName,
  jobDescriptionTitle,
  isLogin,
  onClickLink,
}: Props) => {
  if (!companyName && !jobDescriptionTitle) return [];
  return [
    {
      name: 'Home',
      link: isLogin ? '/home' : '/',
      active: false,
      onClick: () => onClickLink?.('求人計測_ホームクリック'),
    },
    {
      name: '企業一覧',
      link: '/companies',
      active: false,
      onClick: () => onClickLink?.('求人計測_企業一覧クリック'),
    },
    {
      name: companyName,
      link: `/companies/${companyId}`,
      active: false,
      onClick: () => onClickLink?.('求人計測_企業名クリック'),
    },
    {
      name: `${companyName}の求人情報`,
      link: `/companies/${companyId}/jobs`,
      active: false,
      onClick: () => onClickLink?.('求人計測_企業求人情報クリック'),
    },
    {
      name: jobDescriptionTitle,
      active: true,
    },
  ];
};
